import { Tile } from '#src/components/series/SeriesBoard/HotStreakTile/Tile/index.tsx';
import {
  DiamondBaseColor,
  DiamondBasePosition,
} from '#src/components/series/SeriesBoard/HotStreakTile/Tile/utils.ts';

export const ClaimableTile = () => {
  return (
    <Tile
      color={DiamondBaseColor.blue}
      position={DiamondBasePosition.up}
      floating
    />
  );
};
